module.exports = __webpack_public_path__ + "media/application/images/svgs/trash-2-69a414d1581e22e6650190158c8c7dc4.svg";